import React from "react";
import "./style/style-pc.css";
import "./style/style-mob.css";
import img from "../../resources/logo.webp";
import { useNavigate } from "react-router-dom";

export const Admin = () => {
    const navigate = useNavigate();

    const GoToVacation = () => {
        navigate("/admin-vacation");
    };

    const GoToHaircuts = () => {
        navigate("/admin-haircuts");
    };

    const GoToAppointments = () => {
        navigate("/admin-appointments");
    };

    const GoToEducationPrices = () => {
        navigate("/admin-education-prices");
    };

    const GoToEducationSlots = () => {
        navigate("/admin-education-slots");
    };

    const GoToEducationApplications = () => {
        navigate("/admin-education-applications");
    };

    const GoToSettings = () => {
        navigate("/");
    };

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <h1>Dobrodošao</h1>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToAppointments}
            >
                Pregled Termina
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToHaircuts}
            >
                Usluge i Cene
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToEducationPrices}
            >
                Cene Edukacija
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToEducationSlots}
            >
                Termini - Edukacije
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToEducationApplications}
            >
                Prijave - Edukacije
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToVacation}
            >
                Obriši korisnika
            </button>
            <button
                className='barber-zajednica-admin-button'
                onClick={GoToSettings}
            >
                Početna strana
            </button>
            <div className='barber-zajednica-admin-logo'>
                <img src={img} />
            </div>
        </div>
    );
};
